export default __webpack_public_path__ + "static/media/creative-copywriter.b636e844.gif";